module.exports = __webpack_public_path__ + "static/media/IKMS03.bc8fb0e1.jpg";